import { Link } from 'react-router-dom';
import '../../index.css';
import styles from './forgot-password.module.css';

export interface ForgotPasswordPageProps { }

export const ForgotPasswordPage = (props: ForgotPasswordPageProps) => {

	function handleClick(): void {
		alert('Hello World');
	}

	return (
		<div className={styles.forgotPasswordPage}>
			<div className={styles.forgotPassword}>
				<h3>Forgot Password?</h3>
				<p>Please enter your login ID and we will send you a password reset link for you to reset your password</p>
				<hr />
				<div className="form-field">
					<label htmlFor="loginId" className={styles.controlLabel}>Login ID <span>*</span></label>
					<input className='form-control' placeholder='Login ID / Phone / Email' type="text" name="loginId" id="loginId" />
				</div>
				<div className={styles.loginButtonContainer}>
					<button type="submit" className={styles.loginButton} onClick={handleClick} >
						Submit
					</button>
				</div>
				<p>Already got your password? <Link to="/login">Sign in here</Link></p>
			</div>
		</div>
	);
};